import React, { useEffect, useState, useCallback } from "react";
import * as actions from "../Common/actions";
import {
  Grid,
  Paper,
  Box,
  Table,
  TableRow,
  TableCell,
  TableContainer,
  TableHead,
  TableBody,
  TextField,
} from "@mui/material";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import _ from "lodash";
import SelectCMP from "react-select";
import { ticketOptions } from "../../constants";

export default function Tickets(props) {
  const [tickets, setTickets] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [selectedTicketType, setSelectedTicketType] = useState({
    label: "All",
    value: "all",
  });
  const debouncedSearch = useCallback(
    _.debounce((value) => {
      onGetAllTickets({ search: value });
    }, 500),
    [selectedTicketType]
  );

  const onGetAllTickets = (filters) => {
    props.setLoader(true);
    actions
      .getTicketListForAdmin({ ...filters, sort: selectedTicketType.value })
      .then((res) => {
        props.setLoader(false);
        setTickets(res.body);
      })
      .catch(() => {
        props.setLoader(false);
      });
  };

  const onChangeSearch = (e) => {
    const value = e.target.value;
    setSearchText(value);
    debouncedSearch(value);
  };

  useEffect(() => {
    onGetAllTickets({ search: searchText });
  }, [selectedTicketType]);

  useEffect(() => {
    onGetAllTickets({ search: searchText });
  }, []);

  return (
    <Grid container>
      <Grid item xs={12} sm={8} md={10}>
        <Box mt={2} mb={2}>
          <TextField
            name="Search"
            type="text"
            variant="outlined"
            size="small"
            value={searchText}
            onChange={onChangeSearch}
            fullWidth
          />
        </Box>
      </Grid>

      <Grid item xs={12} sm={4} md={2}>
        <Box mt={2} mb={2} pl={2}>
          <SelectCMP
            options={ticketOptions}
            value={selectedTicketType}
            onChange={(e) => setSelectedTicketType(e)}
          />
        </Box>
      </Grid>

      <Grid item xs={12}>
        <TableContainer component={Paper}>
          <Table className="universal-table">
            <TableHead>
              <TableRow
                style={{
                  background:
                    "linear-gradient(90deg, rgba(19,153,121,1) 0%, rgba(18,180,161,1) 45%, rgba(5,150,179,1) 100%)",
                }}
              >
                <TableCell className="color-white">No.</TableCell>
                <TableCell className="color-white">Ticket No.</TableCell>
                <TableCell className="color-white">Name</TableCell>
                <TableCell className="color-white">Email</TableCell>
                <TableCell className="color-white">Reason</TableCell>
                <TableCell className="color-white">Date</TableCell>
                <TableCell className="color-white">Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tickets.length ? (
                tickets.map((item, key) => {
                  return (
                    <TableRow key={key}>
                      <TableCell>{key + 1}</TableCell>
                      <TableCell>
                        <Link
                          to={`/view_tickets/${item.ticket_id}`}
                          className="link-color-black"
                        >
                          {item.ticket_id || "-"}
                        </Link>
                      </TableCell>
                      <TableCell>{item.user_name}</TableCell>
                      <TableCell>{item.user_email}</TableCell>
                      <TableCell>{item.reason}</TableCell>
                      <TableCell>
                        {moment(item.date).format("DD/MM/yyyy")}
                      </TableCell>
                      <TableCell>
                        {item.status === 0 ? (
                          <span>Open</span>
                        ) : (
                          <span style={{ color: "green" }}>Closed</span>
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell align="center" colSpan="7">
                    No Report Found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
}